import React from 'react';
import { Modal, Table } from 'semantic-ui-react';
import { ViewModalProps } from './types';
import {
  Container,
  FormContainer,
  Form,
  Line,
  FormTitle,
  FormContent,
  FormRow
} from './styles';
import { maskCpfOrCnpj, maskPhoneNumber } from '../../../../services/masks';
import { statusOptions } from '../../types';
import { DateToStringDate } from '../../../../services/date';

const ViewModal: React.FC<ViewModalProps> = ({
  isOpen,
  onClose,
  multiFranchise
}: ViewModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal open={isOpen} onClose={onClose} closeIcon>
      <Container>
        <Form>
          <FormContainer>
            <FormTitle>DADOS CADASTRAIS</FormTitle>
            <Line />
            <FormContent>
              <FormRow>
                <label>
                  <b>NOME </b>
                  <span>{multiFranchise?.responsible_name}</span>
                </label>

                <label>
                  <b>CONTATO</b>
                  <span>{maskPhoneNumber(multiFranchise?.responsible_phone)}</span>
                </label>
                <label>
                  <b>STATUS</b>
                  <span>
                    {
                      statusOptions.find(
                        status => status.value === multiFranchise?.status
                      )?.text
                    }
                  </span>
                </label>
              </FormRow>
              <FormRow>
                <label>
                  <b>EMAIL</b>
                  <span>{multiFranchise?.responsible_email}</span>
                </label>
              </FormRow>
            </FormContent>
          </FormContainer>
          <FormContainer>
            <FormTitle>FRANQUIAS</FormTitle>
            <Line />
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Nome</Table.HeaderCell>
                  <Table.HeaderCell>CPF/CNPJ</Table.HeaderCell>
                  <Table.HeaderCell>Telefone</Table.HeaderCell>
                  <Table.HeaderCell>Email</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {multiFranchise?.franchises?.map((franchise: any, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{franchise.name}</Table.Cell>
                    <Table.Cell>{maskCpfOrCnpj(franchise.document)}</Table.Cell>
                    <Table.Cell>{maskPhoneNumber(franchise.phone)}</Table.Cell>
                    <Table.Cell>{franchise.email}</Table.Cell>
                    <Table.Cell>
                      {
                        statusOptions.find(status => status.value === franchise.status)
                          ?.text
                      }
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </FormContainer>
          <FormContainer>
            <FormContent>
              <div className="disclaimer-info">
                <p>
                  Criado em:{' '}
                  {multiFranchise?.created_at
                    ? DateToStringDate(multiFranchise?.created_at)
                    : ''}
                </p>
              </div>
            </FormContent>
          </FormContainer>
        </Form>
      </Container>
    </Modal>
  );
};

export default ViewModal;
